import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { showLiveViewModal } from '../../utils/liveView/showLiveViewModal'
import { playItem } from '../../utils/playItem'
import { createPoll } from '../../utils/createPoll'
import { showNotification } from '../../actions/notifications'
import SectionSelection from '../../components/modals/SectionSelection'

class SectionSelectionContainer extends Component {
  constructor() {
    super()
    this.playForSection = this.playForSection.bind(this)
  }

  playForSection(sectionId) {
    const { mode, itemToPlay, sections } = this.props
    this.props.hideModal()
    // 'queue' mode enqueues the item for the chosen class and surfaces a
    // notification, without leaving the current page. Default 'play' mode
    // starts a Live View session as before.
    if (mode === 'queue') {
      const section = sections.find((s) => s.id === sectionId)
      Promise.resolve(this.props.createPoll(itemToPlay, sectionId)).then(() => {
        const itemLabel = itemToPlay.name || itemToPlay.body || 'Item'
        const sectionName = section ? section.name : 'class'
        this.props.showNotification(`${itemLabel} for ${sectionName}`, 'Queued', 'default')
      })
      return
    }
    this.props.playItem(itemToPlay, sectionId)
    showLiveViewModal()
  }

  render() {
    return (
      <SectionSelection sections={this.props.sections} item={this.props.itemToPlay} mode={this.props.mode} hideModal={this.props.hideModal} playForSection={this.playForSection} />
    )
  }
}

export default withRouter(connect(
  (state) => ({
    sections: state.sections,
    itemToPlay: state.modals.itemToPlay,
    mode: state.modals.sectionSelectionMode,
  }),
  { playItem, createPoll, showNotification },
)(SectionSelectionContainer))
